module.exports = __webpack_public_path__ + "static/media/tree-step-6_1.034196b4.svg";